import styled from 'styled-components';
import { space } from 'styled-system';

const Separator = styled('hr')(
  ({ theme }) => ({
    width: '100%',
    margin: `${theme.space[3]}px 0`,
    padding: 0,
    borderColor: '#E3E4E6'
  }),
  space
);

export default Separator;
